import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
	items: { prop: string; value?: string }[];
	style?: { [key: string]: string | number | null };
}

export default function TaskInfo({ items, style }: Props) {
	const { t } = useTranslation();

	return (
		<div className="task-info-container container" style={style}>
			<div className="activityForm__info">
				{items.map(item => {
					return (
						<div
							className="activityForm__info-item"
							key={item.prop}>
							<div className="activityForm__info-item--prop">
								{item.prop}
							</div>
							<div className="activityForm__info-item--value">
								{item.value || t("main.text.na")}
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
